"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiProfileRepRatesState, RatingStats } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useContext, useEffect, useState } from "react";
import UserPageRepModifyModal from "../modify-rep/UserPageRepModifyModal";
import TopRaterAvatars from "./TopRaterAvatars";
import { getCanEditRep, sortRepsByRatingAndContributors } from "../UserPageRep.helpers";
const TOP_REPS_COUNT = 4;
export default function UserPageRepHeader(t0) {
  const $ = _c(47);
  const {
    repRates,
    profile
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== repRates?.rating_stats) {
    t1 = sortRepsByRatingAndContributors(repRates?.rating_stats ?? []).slice(0, TOP_REPS_COUNT);
    $[0] = repRates?.rating_stats;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [topReps, setTopReps] = useState(t1);
  let t2;
  if ($[2] !== repRates?.rating_stats) {
    t2 = () => {
      setTopReps(sortRepsByRatingAndContributors(repRates?.rating_stats ?? []).slice(0, TOP_REPS_COUNT));
    };
    $[2] = repRates?.rating_stats;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = repRates?.rating_stats;
  let t4;
  if ($[4] !== t3) {
    t4 = [t3];
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t2, t4);
  let t5;
  if ($[6] !== activeProfileProxy || $[7] !== connectedProfile || $[8] !== profile) {
    t5 = getCanEditRep({
      myProfile: connectedProfile,
      targetProfile: profile,
      activeProfileProxy
    });
    $[6] = activeProfileProxy;
    $[7] = connectedProfile;
    $[8] = profile;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [canEditRep, setCanEditRep] = useState(t5);
  let t6;
  let t7;
  if ($[10] !== activeProfileProxy || $[11] !== connectedProfile || $[12] !== profile) {
    t6 = () => {
      setCanEditRep(getCanEditRep({
        myProfile: connectedProfile,
        targetProfile: profile,
        activeProfileProxy
      }));
    };
    t7 = [connectedProfile, profile, activeProfileProxy];
    $[10] = activeProfileProxy;
    $[11] = connectedProfile;
    $[12] = profile;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  const [editCategory, setEditCategory] = useState(null);
  let t8;
  if ($[15] !== canEditRep) {
    t8 = category => {
      if (!canEditRep) {
        return;
      }
      setEditCategory(category);
    };
    $[15] = canEditRep;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const openEditCategory = t8;
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-blue-500/[0.05] tw-via-transparent tw-to-transparent tw-opacity-100" />;
    t10 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-[1px] tw-bg-gradient-to-r tw-from-transparent tw-via-blue-400/40 tw-to-transparent" />;
    t11 = <div className="tw-absolute tw-bottom-0 tw-left-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    t12 = <div className="tw-absolute tw-bottom-0 tw-right-0 tw-top-0 tw-w-[1px] tw-bg-gradient-to-b tw-from-transparent tw-via-blue-400/20 tw-to-transparent" />;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t9;
  } else {
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t9 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="tw-min-w-0"><h2 className="tw-mb-1 tw-text-xl tw-font-semibold tw-text-iron-100">Rep</h2><p className="tw-mb-0 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500">What others recognize this identity for.</p></div>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Total Rep</div>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== repRates) {
    t15 = repRates ? formatNumberWithCommas(repRates.total_rep_rating) : "";
    $[23] = repRates;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15) {
    t16 = <div className="tw-text-3xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-primary-400">{t15}</div>;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== repRates) {
    t17 = repRates && <span className="tw-mt-1 tw-text-sm tw-font-normal tw-text-iron-400">{formatNumberWithCommas(repRates.number_of_raters)}{" "}{repRates.number_of_raters === 1 ? "rater" : "raters"}</span>;
    $[27] = repRates;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t16 || $[30] !== t17) {
    t18 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-6">{t13}<div className="tw-flex tw-flex-shrink-0 tw-flex-col tw-items-end tw-text-right">{t14}{t16}{t17}</div></div>;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== canEditRep || $[33] !== openEditCategory || $[34] !== profile || $[35] !== topReps) {
    t19 = topReps.length > 0 && <div className="tw-mt-6 tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-white/10 tw-pt-6"><div className="tw-mb-4 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Top Rep</div><div className="tw-flex tw-flex-wrap tw-gap-3">{topReps.map(rep => <div key={rep.category} className={`group tw-inline-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-border tw-border-solid tw-border-iron-700/60 tw-bg-iron-900/60 tw-px-4 tw-py-2.5 tw-transition-colors ${canEditRep ? "tw-cursor-pointer hover:tw-border-iron-600/60 hover:tw-bg-iron-800/60" : "tw-cursor-default"}`}>{canEditRep ? <button type="button" onClick={() => openEditCategory(rep.category)} className="tw-inline-flex tw-items-center tw-gap-2.5 tw-appearance-none tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-text-inherit tw-cursor-pointer focus:tw-outline-none"><span className="tw-text-sm tw-font-semibold tw-text-iron-100">{rep.category}</span><span className="tw-text-sm tw-font-semibold tw-text-iron-300 group-hover:tw-text-iron-200">{formatNumberWithCommas(rep.rating)}</span></button> : <div className="tw-inline-flex tw-items-center tw-gap-2.5"><span className="tw-text-sm tw-font-semibold tw-text-iron-100">{rep.category}</span><span className="tw-text-sm tw-font-semibold tw-text-iron-300 group-hover:tw-text-iron-200">{formatNumberWithCommas(rep.rating)}</span></div>}<span className="tw-text-xs tw-text-iron-600">·</span><TopRaterAvatars handleOrWallet={profile.handle ?? ""} category={rep.category} count={3} /><span className="tw-whitespace-nowrap tw-text-xs tw-font-normal tw-text-iron-400">{formatNumberWithCommas(rep.contributor_count)}{" "}{rep.contributor_count === 1 ? "rater" : "raters"}</span></div>)}</div></div>;
    $[32] = canEditRep;
    $[33] = openEditCategory;
    $[34] = profile;
    $[35] = topReps;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t18 || $[38] !== t19) {
    t20 = <div className="tw-relative tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-white/[0.08] tw-bg-gradient-to-br tw-from-[#0f1014] tw-via-[#0A0A0C] tw-to-[#08090b] tw-shadow-2xl">{t9}{t10}{t11}{t12}<div className="tw-relative tw-p-6">{t18}{t19}</div></div>;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== canEditRep || $[41] !== editCategory || $[42] !== profile) {
    t21 = canEditRep && editCategory && <UserPageRepModifyModal profile={profile} category={editCategory} onClose={() => setEditCategory(null)} />;
    $[40] = canEditRep;
    $[41] = editCategory;
    $[42] = profile;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t20 || $[45] !== t21) {
    t22 = <>{t20}{t21}</>;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
}